// extracted by mini-css-extract-plugin
module.exports = {"float-btn-wrap":"eZ","floatBtnWrap":"eZ","float-btn-snapping":"e0","floatBtnSnapping":"e0","float-btn-close":"e1","floatBtnClose":"e1"};